import React from 'react'
import PropTypes from 'prop-types'

import ExclusionModal from 'component/Modal/ExclusionModal'
import Glyph from 'component/utils/Glyph'
import Switch from '../Switch'

const Table = ({
  handleDelete,
  openEditModal,
  records,
  toggleInInactive,
  translate,
}) => {
  const renderHeader = () => (
    <tr>
      <th>{translate('justificationsPa.justificationDesc')}</th>
      <th className='padding-left-4'>{translate('status')}</th>
      <th className='text-align-center'>
        {translate('justificationsPa.table.edit')}
      </th>
      <th className='text-align-center'>
        {translate('justificationsPa.table.remove')}
      </th>
    </tr>
  )

  const renderBody = () => {
    const renderRecord = (record) => {
      const { dsJustification } = record
      const isActive = !record.inInactive

      return (
        <tr key={record.idJustification}>
          <td>{dsJustification}</td>
          <td>
            <Switch
              checked={isActive}
              onChange={() =>
                toggleInInactive([{ ...record, inInactive: isActive ? 1 : 0 }])
              }
            />
            &nbsp;&nbsp;&nbsp;&nbsp;
            {translate(
              isActive ? 'justificationsPa.active' : 'justificationsPa.inactive'
            )}
          </td>
          <td
            onClick={() => openEditModal(record)}
            className='mission-block-edit-icon'
          >
            <Glyph type='pencil' color='primary' />
          </td>
          <td className='mission-block-edit-icon'>
            <ExclusionModal
              confirmButtonMsg='approvers.remove.confirm'
              message={
                <>
                  <br />
                  {translate('justificationsPa.removeModal.text')}
                  <br />
                  <b>{record.dsJustification}</b>
                </>
              }
              onConfirm={() => handleDelete(record)}
              renderButton={({ onClick }) => (
                <Glyph color='danger' onClick={onClick} type='trash-can' />
              )}
              t={translate}
              title={translate('newSectionBlock.remove.title')}
            />
          </td>
        </tr>
      )
    }

    return records.map(renderRecord)
  }

  return (
    <table cellPadding={0} cellSpacing={0} className='new-table'>
      <thead>{renderHeader()}</thead>
      <tbody>{renderBody()}</tbody>
    </table>
  )
}

Table.propTypes = {
  handleDelete: PropTypes.func,
  openEditModal: PropTypes.func.isRequired,
  records: PropTypes.array.isRequired,
  toggleInInactive: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
}

export default Table
